import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    token:"",
    isAuthenticated: false,
    userId:"",
    currentMenu:'',
    teleNum:"",
    role:"",
    menus:{
      //客户主页
      client:[
        {
          name:"客户",
          children:[
            {name:"网上预约",url: "client/index"},
            {name:"我的结果",url: "client/index"},
          ]
        },
      ],
      //呼叫中心
      callcenter:[
        {
          name:"信息管理",
          icon: 'li-icon-dingdanguanli',
          children:[
            {
              name:"预约阶段",
              url: "callCenter/book"
            },
            {
              name:"检查追踪",
              url: "callCenter/feedback"
            },
          ]
        },
        // {
        //   name:"数据统计",
        //   children:[
        //     {name:"客户数据统计",url: "callCenter/statistics"}
        //   ]
        // },
      ],
      //护士
      nurse:[
        {
          name:"检测信息",
          children:[
            {name:"预约阶段"  ,url:"nurse/book" },
            {name:"检查阶段"  ,url:"nurse/check" },
          ]
        },
        
      ],
      //医生
      doctor:[
        {
          name:"判读信息",
          children:[
            {name:"预约阶段"  ,url:"doctor/book" },
           // {name:"到达阶段"  ,url:"doctor/arrival" },
            {name:"检查阶段"  ,url:"doctor/check" },
            {name:"检查追踪"  ,url:"doctor/feedback" },
            {name:"产生报告"  ,url:"https://datacenter0.hyperq.xyz:8080/"}
          ]
        },
        // {
        //   name:"系统管理",
        //   children:[
        //     {name:"暂定" ,url:"" }, 
        //   ]
        // },
      ],
    },
    pagination:{

    },
  },
  mutations:{
    setMenuByRole(state, role) {
      state.currentMenu = state.menus[role]
    },
    setRole(state,role) {
      state.role = role;
    }
  }
})